module.exports = __webpack_public_path__ + "img/jwgl-jcsj-kc.a8bb1297.png";